
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wheels/transportbil/overlanding",
      function () {
        return require("private-next-pages/wheels/transportbil/overlanding.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wheels/transportbil/overlanding"])
      });
    }
  